<template>
    <div id="page" style="background-color: rgba(248, 248, 248, 1);">
        <div class="banner-bg">
            <img src="~@/assets/images/menu/menu_1_banner.png" style="width: 100%;"/>
        </div>
        <section class="section"  style="background-color: rgba(241, 241, 241, 1);height: 70px;padding: 0;">
            <div class="container">
                <div class="row" style="height: 70px;display:flex;align-items: center;">
                    <template v-for="item in key">
                        <div :key="item" class="col-lg-2 col-md-2 active-nav-1" :class="active==item?'active-nav':''" @click="activeChange(item)">{{item}}</div>
                    </template>
                </div>
            </div>
        </section>
        <section class="section" style="padding: 0;" >
            <div class="container">
                <div class="row" style="padding:20px 0;" v-if="active==key[0]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-3 col-md-6"  :key="index" >
                            <router-link :to="{ path:'/biaoqian/articleDetail',query:{id:item.id} }">
                                <div class="list-content">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>{{item.showViewsNum}}人浏览</span></div>
                                </div>
                            </router-link>

                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>

                <div class="row" style="padding:20px 0;" v-if="active==key[1]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-3 col-md-6"  :key="index">
                            <router-link :to="{ path:'/biaoqian/articleDetail',query:{id:item.id} }">
                                <div class="list-content">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>{{item.showViewsNum}}人浏览</span></div>
                                </div>
                            </router-link>

                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>


                <div class="row" style="padding:20px 0;" v-if="active==key[2]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-3 col-md-6"  :key="index">
                            <router-link :to="{ path:'/biaoqian/articleDetail',query:{id:item.id} }">
                                <div class="list-content">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>{{item.showViewsNum}}人浏览</span></div>
                                </div>
                            </router-link>

                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>


                <div class="row" style="padding:20px 0;" v-if="active==key[3]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-3 col-md-6"  :key="index">
                            <router-link :to="{ path:'/biaoqian/articleDetail',query:{id:item.id} }">
                                <div class="list-content">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>{{item.showViewsNum}}人浏览</span></div>
                                </div>
                            </router-link>

                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>

                <div class="row" style="padding:20px 0;" v-if="active==key[4]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-3 col-md-6"  :key="index">
                            <router-link :to="{ path:'/biaoqian/articleDetail',query:{id:item.id} }">
                                <div class="list-content">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>{{item.showViewsNum}}人浏览</span></div>
                                </div>
                            </router-link>

                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {articleList} from "@/api/home"
    import {getSpecialTime}  from "@/utils/tools"
    export default {
        name: "index",
        data() {
            return {
                active:"标准化要闻",
                page:{
                    rows:0,
                    currentPage:1
                },
                key:["标准化要闻","政府奖励奖金","碳标签资讯","标准制定问答","标准制定公告"],
                list:[]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route.params",this.$route.query)
            switch (this.$route.query.active) {
                case "标准制定":
                    this.active = "标准制定公告"
                    break;
                case "标准化要闻":
                    this.active = "标准化要闻"
                    break;
            }
            this.articleList()
        },
        created() {

        },
        methods: {
            getSpecialTime,
            activeChange(value){
                this.active=value
                this.list = []
                this.page.currentPage = 1
                this.page.rows=10
                this.articleList();
            },
            articleList(){

                let data={
                    parentTitle:"碳标签-标准制定",sonTitle:"碳标签-标准化要闻"
                }
                switch (this.active) {
                    case "标准化要闻":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-标准化要闻"}
                        break;
                    case "政府奖励奖金":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-政府奖励奖金"}
                        break;
                    case "碳标签资讯":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-碳标签资讯"}
                        break;
                    case "标准制定问答":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-标准制定问答"}
                        break;
                    case "标准制定公告":
                        data={parentTitle:"碳标签-标准制定",sonTitle:"碳标签-标准制定公告"}
                        break;
                }
                articleList(data).then(res=>{
                    console.log(res)
                    this.list = res.data.records
                    this.page.rows=res.data.total
                })
            }
        }
    }
</script>

<style scoped>

.container{
    width: 1200px;
    min-width: 375px;
}
    .active-nav{
        height: 70px;
        background-color: rgba(2, 171, 57, 1);
        color: #ffffff;
    }
    .active-nav-1{
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-content{
        width: 285px;
        background-color: #ffffff;
        padding-bottom:10px;
        margin-bottom: 15px;
    }
    .text-tip-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        padding: 10px 10px 5px 10px;
        height: 100px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-tip-2{
        padding: 5px 10px;
        display: flex;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #888888;
        line-height: 30px;
    }
    .text-tip-2 span{
        flex:1;
    }
    .text-tip-2 span:nth-child(2){
        text-align: right;
    }
</style>
